<template>
  <span v-if="teamY.id == teamX.id"><i class="fas fa-times"></i></span>
  <span v-else-if="match != null && match.isStarted" @click="reset">
    {{ scoreX }}:{{ scoreY }}
  </span>
</template>

<script>
import { _ } from "../../../extend";

export default {
  name: "admin_bracket_roundRobin_table_match",
  props: {
    teamX: {},
    teamY: {},
    bracketId: {},
  },
  computed: {
    match() {
      const bracketMatches = _.filter(this.$store.getters.matchesWithRelatedData, m => m.bracketId == this.bracketId);
      const match = _.first(bracketMatches, m =>
        (m.bracketTeamAId == this.teamX.id && m.bracketTeamBId == this.teamY.id)
        || (m.bracketTeamAId == this.teamY.id && m.bracketTeamBId == this.teamX.id));
      return match;
    },
    scoreX() {
      // no match
      if (this.match == null) {
        return null;
      }

      // A is X
      if (this.match.bracketTeamAId == this.teamX.id) {
        return this.match.scoreA;
      }

      return this.match.scoreB;
    },
    scoreY() {
      // no match
      if (this.match == null) {
        return null;
      }

      // A is Y
      if (this.match.bracketTeamAId == this.teamY.id) {
        return this.match.scoreA;
      }

      return this.match.scoreB;
    },
  },
  methods: {
    reset() {
      if (!confirm("Chcete resetovat skóre tohoto zápasu?")) {
        return;
      }

      this.$store.commit('update', {
        paths: ['matches', this.match.id, 'scoreA'],
        value: 0,
      });
      this.$store.commit('update', {
        paths: ['matches', this.match.id, 'scoreB'],
        value: 0,
      });
      this.$store.commit('update', {
        paths: ['matches', this.match.id, 'isStarted'],
        value: false,
      });
    },
  },
}
</script>
